import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import { Link } from 'react-router-dom';
import { API_ENDPOINTS } from '../config/api';
import './Auth.css';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await fetch(API_ENDPOINTS.FORGOT_PASSWORD, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (response.ok) {
                setSuccess(true);
            } else {
                setError(data.error || 'Request failed');
            }
        } catch (err) {
            setError('Connection error. Please check your internet and try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-container auth-page">
            <Navbar />
            <div className="auth-card glass">
                <div className="auth-header">
                    <h2>Forgot Password?</h2>
                    <p>Enter your email to reset your password</p>
                </div>

                {error && <div className="error-message">{error}</div>}

                {success ? (
                    <div className="success-container animate-fade-in">
                        <div className="success-message glass" style={{ padding: '30px', border: '1px solid rgba(16, 185, 129, 0.4)' }}>
                            <div style={{ fontSize: '3rem', marginBottom: '20px' }}>📧</div>
                            <h3 style={{ color: '#10b981', marginBottom: '10px' }}>Request Received</h3>
                            <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                                If an account exists with <strong>{email}</strong>, you will receive a password reset link shortly. 
                                Please check your inbox and spam folder.
                            </p>
                        </div>

                        <div className="auth-footer" style={{ marginTop: '30px' }}>
                            <p><Link to="/login" className="btn-secondary">Back to Login</Link></p>
                        </div>
                    </div>
                ) : (
                    <>
                        <form onSubmit={handleSubmit} className="auth-form">
                            <div className="form-group">
                                <label>Email Address</label>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="you@example.com"
                                    required
                                    disabled={loading}
                                />
                            </div>

                            <button
                                type="submit"
                                className="btn-primary btn-block"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner"></span>
                                        Sending...
                                    </>
                                ) : 'Send Reset Link'}
                            </button>
                        </form>

                        <div className="auth-footer">
                            <p>Remember your password? <Link to="/login">Log In</Link></p>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default ForgotPassword;
